<div style="margin:5px"><div class="dialog-header">
  <button mat-icon-button (click)="cerrarDialogo()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<app-detalle-cmf [formularioCMF]="'true'"></app-detalle-cmf>
</div>
<!-- <mat-tab-group>
  <mat-tab label="Agregar CMF">
    <section class="form_section">

      <h2>Formulario CMF</h2>
      <form action="" [formGroup]="formRegisterCmf" (ngSubmit)="submit()" class="form_register_minutes">

        <mat-form-field class="example-form-field">
          <mat-label>Deuda Morosa</mat-label>
          <input mask="separator" thousandSeparator="." matInput formControlName="debtAmount" />
        </mat-form-field>
        <mat-form-field class="example-form-field">
          <mat-label>Dueda Vigente </mat-label>
          <input mask="separator" thousandSeparator="." matInput formControlName="currentAmount" />
        </mat-form-field>
        <mat-form-field class="example-form-field">
          <mat-label>Linea</mat-label>
          <input mask="separator" thousandSeparator="." matInput formControlName="line" />
        </mat-form-field>
        <mat-form-field class="example-form-field">
          <mat-label>Fecha Deuda</mat-label>
          <input [matDatepicker]="picker" matInput formControlName="fechaDeuda" />
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <button mat-stroked-button color="primary" class="w-50" [disabled]="!formRegisterCmf.valid"
          *ngIf="!booleanFlag">
          Guardar
        </button>
      </form>
    </section>
  </mat-tab>

  <mat-tab label="Ver CMF">
    <app-detalle-cmf [formularioCMF]="'true'"></app-detalle-cmf>
  </mat-tab>
</mat-tab-group> -->